// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TJ4l","colBig":"styles_colBig__3SdKI","colSmall":"styles_colSmall__1iVW8"};